import { TimeComparison } from 'generated-graphql/types';
import { MinMax, TableV3FilterItem } from 'common/table/types/TableV3';
import { minMaxToTableFilterItems } from 'common/table/utils/minMaxTableFilterItems';

const LEGACY_TIME_IN_ROLE_BAND_RANGES: Record<string, MinMax<number>> = {
  [TimeComparison.LessThan_1Year]: { max: 1 },
  [TimeComparison.Between_1And_2Years]: { min: 1, max: 2 },
  [TimeComparison.Between_2And_3Years]: { min: 2, max: 3 },
  [TimeComparison.Between_3And_4Years]: { min: 3, max: 4 },
  [TimeComparison.Between_4And_5Years]: { min: 4, max: 5 },
  [TimeComparison.Between_5And_6Years]: { min: 5, max: 6 },
  [TimeComparison.Between_6And_7Years]: { min: 6, max: 7 },
  [TimeComparison.MoreThan_7Years]: { min: 7 }
};

const widenLegacyBandsToOneRange = (
  bands: MinMax<number>[]
): MinMax<number> => {
  const mins = bands.map((band) => band.min);
  const maxes = bands.map((band) => band.max);

  return {
    min: mins.some((min) => min === undefined)
      ? undefined
      : Math.min(...(mins as number[])),
    max: maxes.some((max) => max === undefined)
      ? undefined
      : Math.max(...(maxes as number[]))
  };
};

export const legacyTimeInRoleBandsToTableFilterItems = (
  bands: string[]
): TableV3FilterItem[] => {
  const { min, max } = widenLegacyBandsToOneRange(
    bands.map((band) => LEGACY_TIME_IN_ROLE_BAND_RANGES[band])
  );
  return minMaxToTableFilterItems({
    min: min === undefined ? undefined : String(min),
    max: max === undefined ? undefined : String(max)
  });
};

// Links from before the range filter hold Time in role as bands.
export const withLegacyTimeInRoleBandsAsRange = (
  items: TableV3FilterItem[]
): TableV3FilterItem[] => {
  const bands = items
    .map((item) => item.value)
    .filter((value) => value in LEGACY_TIME_IN_ROLE_BAND_RANGES);
  return bands.length > 0
    ? legacyTimeInRoleBandsToTableFilterItems(bands)
    : items;
};
